<template>
  <Row :gutter="16" style="minHeight: 300px; padding: 16px;">
    <Col span="6">
      <el-button style="width: 100%;padding: 14px 20px;" type="primary" @click="showModal">新增筛查记录</el-button>
      <div
        style="display:flex;flex-direction: column;overflow-y: auto;margin-top: 8px;"
        :style="{ maxHeight: 'calc(100vh - 269px)'}"
      >
        <record-button
          v-if="curIndex === dataSource.length"
          :active="true"
          :value="'新增' + temp_name"
          :show_delete="false"
        ></record-button>
        <record-button
          v-for="(u, i) in dataSource"
          :key="u.id"
          :value="u.alias || u.bind_name"
          :label="u.create_time ? u.create_time.slice(0, 11) : ''"
          :active="i === curIndex"
          @click.native="changeCur(u, i)"
          @remove="remove(u, i)"
        />
      </div>
    </Col>
    <Col span="18">
      <Card v-if="curIndex != -1">
        <more-info-card-title
          slot="title"
          :title="curIndex === dataSource.length ? temp_name : (dataSource[curIndex].alias || dataSource[curIndex].bind_name)"
          :score="score"
          :combo_score="combo_score"
          :qrcode="qrcode"
        />

        <div
          style="display: flex; flex-direction: column;overflow-y: auto;"
          :style="{ maxHeight: 'calc(100vh - 309px)'}"
        >
          <filter-form
            ref="filterForm"
            :title="curIndex === dataSource.length ? temp_name : (dataSource[curIndex].alias || dataSource[curIndex].bind_name)"
            @valid="saveFilter"
          />
          <question-index
            style="overflow: auto; flex: 1"
            ref="question"
            :questId="questId"
            :uniqueId="uniqueId"
            @change="show = false"
            @init="show = true"
            @error="loading = false"
            @success="success"
            @uniqued-result="setUniquedResult"
          ></question-index>
          <div v-if="show" style="text-align: center;padding-top: 10px">
            <el-button type="info" round @click="cancel">取消</el-button>
            <el-button :loading="loading" type="primary" round @click="save">保存</el-button>
          </div>
        </div>
      </Card>
      <div v-if="curIndex === -1 && !dataSource.length" style="position: relative; height: 300px">
        <caring-no-data />
      </div>
    </Col>
    <questionModal
      :isModal="isModal"
      :category_id="category_id"
      @save="saveModal"
      @cancel="cancelModal"
    ></questionModal>
  </Row>
</template>
<script>
import questionIndex from '../../question/index.vue'
import questionModal from '../../common/questionModal.vue'
import recordButton from '../components/recordButton.vue'
import CaringNoData from '../../common/caringNoData.vue'
import filterForm from './filterForm.vue'
import moreInfoCardTitle from './moreInfoCardTitle.vue'
import { APP_QUESTION_URL } from '../../../utils/env'
import { deleteFilterRecordApi } from '../../../api/user'

export default {
  components: {
    questionModal,
    questionIndex,
    recordButton,
    CaringNoData,
    moreInfoCardTitle,
    filterForm,
  },
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Object,
      default: '',
    },
  },
  data() {
    return {
      curIndex: -1,
      questId: '',
      uniqueId: '',
      isModal: false,
      category_id: '2',
      loading: false,
      show: false,
      temp_name: '',
      score: '',
      combo_score: '',
    }
  },
  computed: {
    qrcode() {
      const params = {
        institution_id: this.$store.state.shift.institution_id,
        disease_id: this.$store.state.shift.disease_id,
        dept_id: this.$store.state.shift.dept_id,
        team_ids: [this.$store.state.shift.team_id],
        create_user_id: this.$store.state.user.user.id,
        user_id: this.info.user_id,
        permissions_type: 1,
        name: this.info.name,
        phone: this.info.phone,
        id_card: this.info.id_card,
        province: this.info.province,
        city: this.info.city,
        county: this.info.county,
        address: this.info.address,
        gender: this.info.gender,
        age: this.info.age,
        channel: '二维码',
        biz_type: 'filtrate',
      }
      let url =
        APP_QUESTION_URL +
        '?questId=' +
        this.questId +
        '&uniqueId=' +
        this.uniqueId +
        '&tenant=' +
        this.$store.state.tenant.tenant +
        '&extra=' +
        JSON.stringify(params)
      return url
    },
  },
  created() {
    if (this.dataSource.length) {
      const [u] = this.dataSource
      this.questId = u.bind_code
      this.uniqueId = u.bind_unique
      this.curIndex = 0
    }
  },
  methods: {
    setUniquedResult(res) {
      if (res.code === 0) {
        this.score = res.data.total_score
        this.combo_score = res.data.combo_score
      }
    },
    showModal() {
      this.isModal = true
    },
    changeCur(u, index) {
      if (this.curIndex === index) return
      this.questId = u.bind_code
      this.uniqueId = u.bind_unique
      this.curIndex = index
      this.score = ''
      this.combo_score = ''
      this.show = false
    },
    remove(u, i) {
      deleteFilterRecordApi(u.id).then((res) => {
        if (res.code === 0) {
          this.$Message.error('删除成功')
          if (this.curIndex == i) {
            this.curIndex = -1
          }
          setTimeout(() => {
            this.$emit('success')
          }, 1000)
        }
      })
    },
    cancel() {
      this.curIndex = -1
      this.show = false
    },
    saveFilter(params, type) {
      this.$refs.question.submitbtn(params, type)
    },
    save() {
      // this.loading = true;
      const params = {
        alias: '',
        channel: '管理后台',
        institution_id: this.$store.state.shift.institution_id,
        disease_id: this.$store.state.shift.disease_id,
        dept_id: this.$store.state.shift.dept_id,
        team_ids: [this.$store.state.shift.team_id],
        create_user_id: this.$store.state.user.user.id,
        user_id: this.info.user_id,
        permissions_type: 1,
        name: this.info.name,
        phone: this.info.phone,
        id_card: this.info.id_card,
        province: this.info.province,
        city: this.info.city,
        county: this.info.county,
        address: this.info.address,
        gender: this.info.gender,
        age: this.info.age,
      }
      this.$refs.filterForm.validate(params, 'filtrate')
    },
    success() {
      this.loading = false
      this.curIndex = -1
      this.show = false
      setTimeout(() => {
        this.$emit('success')
      }, 1000)
    },
    cancelModal() {
      this.isModal = false
    },
    saveModal(data) {
      if (data && data.length) {
        this.questId = data[0].questionnaire_id
        this.uniqueId = ''
        this.curIndex = this.dataSource.length
        this.temp_name = data[0].questionnaire_name
        this.show = false
        this.isModal = false
        this.score = ''
        this.combo_score = ''
      } else {
        this.$Message.warning('请选择筛查问卷')
      }
    },
  },
}
</script>
